module.exports = __webpack_public_path__ + "static/media/bhs_icon_benefits.7ab8b4f6.png";